import {
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { IconInjectorComponent } from '../icon-injector/icon-injector.component';

@Component({
  selector: 'lib-andromeda-search-input',
  templateUrl: './andromeda-search-input.component.html',
  styleUrls: ['./andromeda-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AndromedaSearchInputComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [IconInjectorComponent, ReactiveFormsModule],
})
export class AndromedaSearchInputComponent
  implements ControlValueAccessor, OnInit
{
  @Input() placeholderValue = 'Rechercher';
  @Input() title?: string;
  @Input() parentForm?: UntypedFormGroup;
  @Input() formControlName? = 'default';
  @ViewChild('input', { static: true }) input!: ElementRef<HTMLInputElement>;

  value = '';
  disabled = false;

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-empty-function
  onChange: (value: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: () => void = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  ngOnInit(): void {
    if (!this.parentForm) {
      this.parentForm = new UntypedFormGroup({});
    }
    this.parentForm.addControl(
      this.formControlName!,
      new UntypedFormControl(this.value)
    );
  }

  writeValue(value: string): void {
    this.value = value || '';
    if (this.input) {
      this.input.nativeElement.value = this.value;
    }
  }

  // eslint-disable-next-line no-unused-vars
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.input) {
      this.input.nativeElement.disabled = isDisabled;
    }
  }

  onInputChange(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(this.value);
    this.onTouched();
  }

  focusOnInput(): void {
    this.input.nativeElement.focus();
  }
}
